function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimerGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.154,2.288L9.154,0L18.308,0L18.308,2.288L9.154,2.288ZM12.586,19.337L14.875,19.337L14.875,10.565L12.586,10.565L12.586,19.337ZM13.731,32C11.849,32 10.075,31.638 8.41,30.913C6.745,30.188 5.289,29.203 4.043,27.957C2.797,26.711 1.812,25.255 1.087,23.59C0.362,21.925 -0,20.151 -0,18.269C-0,16.388 0.362,14.614 1.087,12.949C1.812,11.283 2.797,9.828 4.043,8.582C5.289,7.336 6.745,6.35 8.41,5.626C10.075,4.901 11.849,4.539 13.731,4.539C15.434,4.539 17.036,4.825 18.536,5.397C20.037,5.969 21.371,6.764 22.541,7.781L24.486,5.836L26.088,7.437L24.143,9.383C25.058,10.4 25.84,11.633 26.489,13.082C27.137,14.532 27.461,16.261 27.461,18.269C27.461,20.151 27.099,21.925 26.374,23.59C25.65,25.255 24.664,26.711 23.418,27.957C22.172,29.203 20.717,30.188 19.051,30.913C17.386,31.638 15.612,32 13.731,32ZM13.731,29.712C16.909,29.712 19.611,28.599 21.836,26.374C24.06,24.149 25.173,21.448 25.173,18.269C25.173,15.091 24.06,12.389 21.836,10.164C19.611,7.94 16.909,6.827 13.731,6.827C10.552,6.827 7.851,7.94 5.626,10.164C3.401,12.389 2.288,15.091 2.288,18.269C2.288,21.448 3.401,24.149 5.626,26.374C7.851,28.599 10.552,29.712 13.731,29.712Z",
    style: {
      fill: "rgb(150,150,150)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimerGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/timer-grey.2f07858036c9a5b3ad4ae194de4ce938.svg";